import { useState } from "react";

import { Box } from "@mui/material";

import { faImage } from "@fortawesome/free-solid-svg-icons";

import EditableContentBlock from "../../atoms/EditableContentBlock";
import FileUploadDropzone from "../../atoms/FileUploadDropzone";

const EditableImageUploadDropzone = ({
  onSave,
  imageName,
  imageUrl,
  isLoading,
  backgroundSize = "cover",
  contentStyle = {},
  previewImageStyle = {},
  children,
  ...otherProps
}) => {
  const [imageFile, setImageFile] = useState(null);

  const onImageSave = async () => {
    await onSave(imageFile);
    return setImageFile(null);
  };

  return (
    <EditableContentBlock
      {...otherProps}
      padding={0}
      elementName={imageName}
      contentLoading={isLoading}
      isEditableByDefault={!imageUrl}
      imageFile={imageFile}
      content={
        imageUrl ? (
          <Box
            style={{
              height: "100%",
              width: "100%",
              backgroundImage: `url(${imageUrl})`,
              backgroundSize,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              ...contentStyle,
            }}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {children}
          </Box>
        ) : (
          <FileUploadDropzone
            imageName={imageName}
            onImageUpload={onImageSave}
            previewImageStyle={previewImageStyle}
          />
        )
      }
      editingInterface={
        <FileUploadDropzone
          setFile={setImageFile}
          fileName={imageName}
          previewImageStyle={previewImageStyle}
          icon={faImage}
        />
      }
      onSave={onImageSave}
      saveDisabled={!imageFile}
    />
  );
};
export default EditableImageUploadDropzone;
